export default "__VITE_ASSET__1b31e43e__"